import type { OnboardingTasks } from './store';

/**
 * Whether a customer with open onboarding tasks goes to the legacy `/confirm-entry` page: their only
 * task is confirming a missed entry and they're not in express onboarding. Express customers confirm
 * inside `/onboard` (ConfirmEntry step) instead.
 */
export function needsLegacyConfirmEntry(
  tasks: OnboardingTasks | null | undefined,
  expressOnboardingExperimentGroup: string | null | undefined,
): boolean {
  return (
    expressOnboardingExperimentGroup !== 'treatment' &&
    !!tasks?.missedEntryStartVisit &&
    tasks.list.length === 1
  );
}
